export default __webpack_public_path__ + "static/media/IMG_5555.e70914f6.jpg";